import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const MobileHeroSection = (): ReactElement => {
  const { t: tMobile } = useTranslation('', {
    keyPrefix: '$pages.$home.$mobileHomePage.$heroSection',
  });

  return (
    <section className="mobile-hero">
      <h2
        className="mobile-hero-title heading-flexbox"
        dangerouslySetInnerHTML={{ __html: tMobile('title') }}
      />
      <picture>
        <source srcSet="/images/misc/fill.gif" media="(min-width: 769px)" />
        <img
          src="/statics/img/mobile/hero.webp"
          alt={tMobile('heroImageAlt')}
          width={768}
          height={384}
          loading="eager"
          fetchPriority="high"
        />
      </picture>
    </section>
  );
};

export default MobileHeroSection;
